module.exports = __webpack_public_path__ + "static/img/nodata.fe0411f0.png";